import { Typography, lighten, useTheme } from '@mui/material';
import { AutogiroMandateStatusEnum } from 'src/shared/models/enums/autogiroMandateStatus.enum';
import { useTranslation } from 'react-i18next';
import { AutogiroMandateResponse } from '../models/autogiroMandateResponse';

type AutogiroMandateSendStatusProps = {
  item: AutogiroMandateResponse;
};

export const AutogiroMandateStatus = (props: AutogiroMandateSendStatusProps) => {
  const { item } = props;
  const { t } = useTranslation(['invoice']);

  const thm = useTheme();

  let bgColor = '';
  let textColor = '';
  let statusDotColor = '';
  let border = `none`;
  let label = '';
  switch (item.status as AutogiroMandateStatusEnum) {
    case AutogiroMandateStatusEnum.New:
      bgColor = `${lighten(thm.palette.warning.main, 0.8)}`;
      textColor = `${thm.palette.text.primary}`;
      statusDotColor = `${thm.palette.warning.main}`;
      border = `1px solid ${thm.palette.warning.main}`;
      label = t('invoice:autogiroMandateStatus.New');
      break;
    case AutogiroMandateStatusEnum.PendingApproval:
      bgColor = `${lighten(thm.palette.success.main, 0.9)}`;
      textColor = `${thm.palette.text.primary}`;
      statusDotColor = `${lighten(thm.palette.success.main, 0.9)}`;
      border = `1px solid ${thm.palette.success.main}`;
      label = t('invoice:autogiroMandateStatus.PendingApproval');
      break;
    case AutogiroMandateStatusEnum.NotApproved:
      bgColor = `${lighten(thm.palette.error.main, 0.9)}`;
      textColor = `${thm.palette.text.primary}`;
      statusDotColor = `${thm.palette.error.main}`;
      label = t('invoice:autogiroMandateStatus.NotApproved');
      break;
    case AutogiroMandateStatusEnum.Approved:
      bgColor = `${lighten(thm.palette.success.main, 0.9)}`;
      textColor = `${thm.palette.text.primary}`;
      statusDotColor = thm.palette.success.main;
      label = t('invoice:autogiroMandateStatus.Approved');
      break;
    case AutogiroMandateStatusEnum.PendingCancel:
      bgColor = `${thm.palette.grey[200]}`;
      textColor = `${thm.palette.text.secondary}`;
      statusDotColor = `${thm.palette.grey[200]}`;
      border = `1px solid ${thm.palette.grey[500]}`;
      label = t('invoice:autogiroMandateStatus.PendingCancel');
      break;
    case AutogiroMandateStatusEnum.Canceled:
      bgColor = `${thm.palette.grey[200]}`;
      textColor = `${thm.palette.text.secondary}`;
      statusDotColor = `${thm.palette.grey[400]}`;
      label = t('invoice:autogiroMandateStatus.Canceled');
      break;
    case AutogiroMandateStatusEnum.Error:
      bgColor = `${lighten(thm.palette.error.main, 0.9)}`;
      textColor = `${thm.palette.text.primary}`;
      statusDotColor = `${thm.palette.error.main}`;
      label = t('invoice:autogiroMandateStatus.Error');
      break;
    default:
      bgColor = `${thm.palette.grey[200]}`;
      textColor = `${thm.palette.grey[200]}`;
  }

  return (
    <Typography
      variant='body2'
      sx={{
        position: 'relative',
        fontSize: '0.8rem',
        backgroundColor: bgColor,
        color: textColor,
        boxSizing: 'border-box',
        borderRadius: 1,
        pl: 2.75,
        pr: 1,
        py: 0.25,

        '&::after': {
          position: 'absolute',
          content: '" "',
          top: '50%',
          left: thm.spacing(1),
          mt: '-4px',
          backgroundColor: statusDotColor,
          border,
          width: '8px',
          height: '8px',
          borderRadius: '500rem',
        },
      }}
    >
      {label}
    </Typography>
  );
};
